var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("h3", [_vm._v(_vm._s(_vm.$t("search.heading")))]),
    _vm._v(" "),
    _c("ul", { staticClass: "nav nav-tabs", attrs: { id: "searchTabs" } }, [
      _c(
        "li",
        {
          class: { active: _vm.activePattern === "simple" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.activePattern = "simple"
            },
          },
        },
        [
          _c("a", { staticClass: "querytype", attrs: { href: "#simple" } }, [
            _vm._v(_vm._s(_vm.$t("search.simple.heading"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.activePattern === "extended" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.activePattern = "extended"
            },
          },
        },
        [
          _c("a", { staticClass: "querytype", attrs: { href: "#extended" } }, [
            _vm._v(_vm._s(_vm.$t("search.extended.heading"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.advancedEnabled
        ? _c(
            "li",
            {
              class: { active: _vm.activePattern === "advanced" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activePattern = "advanced"
                },
              },
            },
            [
              _c(
                "a",
                { staticClass: "querytype", attrs: { href: "#advanced" } },
                [_vm._v(_vm._s(_vm.$t("search.advanced.heading")))]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.conceptEnabled
        ? _c(
            "li",
            {
              class: { active: _vm.activePattern === "concept" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activePattern = "concept"
                },
              },
            },
            [
              _c(
                "a",
                { staticClass: "querytype", attrs: { href: "#concept" } },
                [_vm._v(_vm._s(_vm.$t("search.concept.heading")))]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.glossEnabled
        ? _c(
            "li",
            {
              class: { active: _vm.activePattern === "glosses" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activePattern = "glosses"
                },
              },
            },
            [
              _c(
                "a",
                { staticClass: "querytype", attrs: { href: "#glosses" } },
                [_vm._v(_vm._s(_vm.$t("search.glosses.heading")))]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        {
          class: { active: _vm.activePattern === "expert" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.activePattern = "expert"
            },
          },
        },
        [
          _c("a", { staticClass: "querytype", attrs: { href: "#expert" } }, [
            _vm._v(_vm._s(_vm.$t("search.expert.heading"))),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content", class: { parallel: _vm.isParallelCorpus } },
      [
        _c(
          "div",
          {
            class: [
              "tab-pane form-horizontal",
              { active: _vm.activePattern === "simple" },
            ],
            attrs: { id: "simple" },
          },
          [
            _vm.isParallelCorpus
              ? _c("ParallelSourceAndTargets", {
                  attrs: {
                    block: "",
                    lg: "",
                    errorNoParallelSourceVersion:
                      _vm.errorNoParallelSourceVersion,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group form-group-lg" },
              [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: {
                      for: _vm.simpleSearchAnnotation.id + "_" + _vm.uid,
                      title: _vm.$tAnnotDescription(_vm.simpleSearchAnnotation),
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$tAnnotDisplayName(_vm.simpleSearchAnnotation)
                      ) + "\n\t\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.customAnnotations[_vm.simpleSearchAnnotation.id]
                  ? _c("div", {
                      ref: "_simple",
                      attrs: {
                        "data-custom-annotation-root":
                          _vm.simpleSearchAnnotation.id,
                        "data-is-simple": "true",
                      },
                    })
                  : _c("Annotation", {
                      key: "simple/" + _vm.simpleSearchAnnotation.id,
                      attrs: {
                        htmlId: "simple/" + _vm.simpleSearchAnnotation.id,
                        annotation: _vm.simpleSearchAnnotation,
                        bare: "",
                        simple: "",
                      },
                    }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "tab-pane form-horizontal",
              { active: _vm.activePattern === "extended" },
            ],
            attrs: { id: "extended" },
          },
          [
            _vm.isParallelCorpus
              ? _c("ParallelSourceAndTargets", {
                  attrs: {
                    errorNoParallelSourceVersion:
                      _vm.errorNoParallelSourceVersion,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.useTabs
              ? [
                  _c(
                    "ul",
                    {
                      staticClass: "nav nav-tabs subtabs",
                      staticStyle: { "padding-left": "15px" },
                    },
                    _vm._l(_vm.tabs, function (tab) {
                      return _c(
                        "li",
                        {
                          key: tab.id,
                          class: { active: _vm.activeAnnotationTab === tab.id },
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" + tab.id },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.activeAnnotationTab = tab.id
                                },
                              },
                            },
                            [_vm._v(_vm._s(tab.label))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab-content" },
                    _vm._l(_vm.tabs, function (tab) {
                      return _c(
                        "div",
                        {
                          key: tab.id,
                          class: [
                            "tab-pane",
                            "annotation-container",
                            { active: _vm.activeAnnotationTab === tab.id },
                          ],
                          attrs: { id: tab.id },
                        },
                        [
                          _vm._l(tab.entries, function (annotation) {
                            return [
                              _vm.customAnnotations[annotation.id]
                                ? _c("div", {
                                    key: tab.id + "/" + annotation.id,
                                    ref: tab.id + "/" + annotation.id,
                                    refInFor: true,
                                    attrs: {
                                      "data-custom-annotation-root":
                                        annotation.id,
                                    },
                                  })
                                : _c("Annotation", {
                                    key:
                                      tab.id + "/" + annotation.id + "/builtin",
                                    attrs: {
                                      htmlId: tab.id + "/" + annotation.id,
                                      annotation: annotation,
                                    },
                                  }),
                            ]
                          }),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]
              : [
                  _vm._l(_vm.allAnnotations, function (annotation) {
                    return [
                      _vm.customAnnotations[annotation.id]
                        ? _c("div", {
                            key: annotation.id + "/custom",
                            ref: annotation.id,
                            refInFor: true,
                            attrs: {
                              "data-custom-annotation-root": annotation.id,
                            },
                          })
                        : _c("Annotation", {
                            key: annotation.id + "/builtin",
                            attrs: {
                              htmlId: annotation.id,
                              annotation: annotation,
                            },
                          }),
                    ]
                  }),
                ],
            _vm._v(" "),
            _c("Within", {
              model: {
                value: _vm.within,
                callback: function ($$v) {
                  _vm.within = $$v
                },
                expression: "within",
              },
            }),
            _vm._v(" "),
            _vm.splitBatchEnabled
              ? _c("div", { staticClass: "form-group" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-xs-12 col-md-9 col-md-push-3 checkbox",
                    },
                    [
                      _c("label", { attrs: { for: "extended_split_batch" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.splitBatch,
                              expression: "splitBatch",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "extended_split_batch",
                            id: "extended_split_batch",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.splitBatch)
                              ? _vm._i(_vm.splitBatch, null) > -1
                              : _vm.splitBatch,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.splitBatch,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.splitBatch = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.splitBatch = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.splitBatch = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("search.extended.splitBatch")) +
                            "\n\t\t\t\t\t"
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.useTabs || _vm.allAnnotations.length > 1
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.copyExtendedQuery },
                  },
                  [_vm._v(_vm._s(_vm.$t("search.advanced.copyAdvancedQuery")))]
                )
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.advancedEnabled
          ? _c(
              "div",
              {
                class: [
                  "tab-pane",
                  { active: _vm.activePattern === "advanced" },
                ],
                attrs: { id: "advanced" },
              },
              [
                _c("SearchAdvanced", {
                  attrs: {
                    errorNoParallelSourceVersion:
                      _vm.errorNoParallelSourceVersion,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.conceptEnabled
          ? _c(
              "div",
              {
                class: [
                  "tab-pane",
                  { active: _vm.activePattern === "concept" },
                ],
                attrs: { id: "concept" },
              },
              [
                _c("ConceptSearch"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.copyConceptQuery },
                  },
                  [_vm._v(_vm._s(_vm.$t("search.concept.copyConceptQuery")))]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.glossEnabled
          ? _c(
              "div",
              {
                class: [
                  "tab-pane",
                  { active: _vm.activePattern === "glosses" },
                ],
                attrs: { id: "glosses" },
              },
              [
                _c("GlossSearch"),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-top": "2em" } }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default btn-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.copyGlossQuery },
                  },
                  [_vm._v(_vm._s(_vm.$t("search.glosses.copyGlossQuery")))]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            class: ["tab-pane", { active: _vm.activePattern === "expert" }],
            attrs: { id: "expert" },
          },
          [
            _c("SearchExpert", {
              attrs: {
                errorNoParallelSourceVersion: _vm.errorNoParallelSourceVersion,
              },
            }),
            _vm._v(" "),
            [
              _vm.advancedEnabled
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      attrs: {
                        type: "button",
                        name: "parseQuery",
                        id: "parseQuery",
                        title: _vm
                          .$t("search.expert.parseQueryTitle")
                          .toString(),
                      },
                      on: { click: _vm.parseQuery },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.expert.parseQuery")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "btn btn-sm btn-default file-input-button",
                  attrs: { for: "importQuery" },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("search.expert.importQuery")) +
                      "\n\t\t\t\t\t"
                  ),
                  _c("input", {
                    attrs: {
                      type: "file",
                      name: "importQuery",
                      id: "importQuery",
                      accept: ".txt,text/plain",
                      title: _vm.$t("search.expert.importQueryTitle"),
                    },
                    on: { change: _vm.importQuery },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btn-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "btn btn-sm btn-default file-input-button",
                    attrs: { for: "gapFilling" },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("search.expert.gapFilling")) +
                        "\n\t\t\t\t\t\t"
                    ),
                    _c("input", {
                      attrs: {
                        type: "file",
                        name: "gapFilling",
                        id: "gapFilling",
                        accept: ".tsv,.csv,text/plain",
                        title: _vm.$t("search.expert.gapFillingTitle"),
                      },
                      on: { change: _vm.importGapFile },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.gapValue != null
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-sm",
                        attrs: {
                          type: "button",
                          title: _vm
                            .$t("search.expert.clearGapValues")
                            .toString(),
                        },
                        on: {
                          click: function ($event) {
                            _vm.gapValue = null
                          },
                        },
                      },
                      [_c("span", { staticClass: "fa fa-times" })]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.gapValue != null
                ? _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.lazy",
                        value: _vm.gapValue,
                        expression: "gapValue",
                        modifiers: { lazy: true },
                      },
                    ],
                    staticClass: "form-control gap-value-editor",
                    attrs: { type: "area" },
                    domProps: { value: _vm.gapValue },
                    on: {
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        )
                          return null
                        $event.preventDefault()
                        return _vm.insertTabInText.apply(null, arguments)
                      },
                      change: function ($event) {
                        _vm.gapValue = $event.target.value
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.parseQueryError,
                      expression: "parseQueryError",
                    },
                  ],
                  staticClass: "text-danger",
                  attrs: { id: "parseQueryError" },
                },
                [
                  _c("span", { staticClass: "fa fa-exclamation-triangle" }),
                  _vm._v(" " + _vm._s(_vm.parseQueryError)),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.importQueryError,
                      expression: "importQueryError",
                    },
                  ],
                  staticClass: "text-danger",
                  attrs: { id: "importQueryError" },
                },
                [
                  _c("span", { staticClass: "fa fa-exclamation-triangle" }),
                  _vm._v(" " + _vm._s(_vm.importQueryError)),
                ]
              ),
            ],
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }